module.exports = __webpack_public_path__ + "img/2.81d2f725.png";